import React from 'react';
import { Card, Button, List, Toast } from 'antd-mobile';
import { useNavigate } from 'react-router-dom';
import { clearAuth } from '../api';

function ProfilePage() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const handleLogout = () => {
    clearAuth();
    Toast.show({ icon: 'success', content: 'Вы вышли из системы' });
    navigate('/login');
  };

  return (
    <div>
      <h3 style={{ marginTop: 0 }}>Профиль</h3>
      <Card>
        <div style={{ textAlign: 'center', marginBottom: 16 }}>
          <div style={{
            width: 80, height: 80, borderRadius: '50%', background: '#1890ff',
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 32, color: '#fff', fontWeight: 'bold'
          }}>
            {(user.full_name || 'Э').charAt(0)}
          </div>
          <h3 style={{ margin: '12px 0 4px' }}>{user.full_name}</h3>
          <div style={{ color: '#888' }}>{user.department}</div>
          <div style={{ color: '#888', fontSize: 12 }}>{user.role === 'expert' ? 'Эксперт' : user.role}</div>
        </div>
      </Card>

      <List style={{ marginTop: 12 }}>
        <List.Item extra="v1.0.0">Версия приложения</List.Item>
        <List.Item extra="Онлайн">Статус синхронизации</List.Item>
        <List.Item extra="42">Выполнено за месяц</List.Item>
      </List>

      <Button block color="danger" style={{ marginTop: 24 }} onClick={handleLogout}>
        Выйти
      </Button>
    </div>
  );
}

export default ProfilePage;
